import { ChatsPageCustomerNumberUsageQuery } from '../../../generated';

export type CustomerNumberUsage = {
  chatId: string;
  name: string;
};

/**
 * Other chats of the distributor that already use `customerNumber`.
 * The search is fuzzy, so only exact matches count.
 */
export const getOtherChatsUsingCustomerNumber = (
  result: ChatsPageCustomerNumberUsageQuery['searchCustomerChats'] | undefined,
  customerNumber: string,
  chatId: string
): CustomerNumberUsage[] => {
  if (result?.__typename !== 'CustomerChatsConnection') return [];

  return result.edges
    .map((edge) => edge.node)
    .filter(
      (chat) =>
        chat.id !== chatId && chat.customerNumber?.trim() === customerNumber
    )
    .map((chat) => ({
      chatId: chat.id,
      name: chat.restaurantName?.trim() || chat.chatName?.trim() || chat.id,
    }));
};
